(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcb-homepage"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-bcb-campaign]');
    if (!root) return;
    var slides = [].slice.call(root.querySelectorAll('[data-bcb-slide]')),
      dots = [].slice.call(root.querySelectorAll('[data-bcb-dot]')),
      i = 0,
      timer = null,
      startX = 0,
      startY = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) {
        s.classList.toggle('is-active', x === i);
        s.setAttribute('aria-hidden', x === i ? 'false' : 'true');
      });
      dots.forEach(function (d, x) {
        d.classList.toggle('is-active', x === i);
      });
    }
    function start() {
      clearInterval(timer);
      timer = setInterval(function () {
        show(i + 1);
      }, 6000);
    }
    function manual(n) {
      show(n);
      start();
    }
    dots.forEach(function (d, x) {
      d.onclick = function () {
        manual(x);
      };
    });
    root.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startX,
          dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy)) {
          manual(dx < 0 ? i + 1 : i - 1);
        }
      },
      { passive: true }
    );
    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
